import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { TopRibbonComponent } from './top-ribbon.component';

@NgModule({
	declarations: [TopRibbonComponent],
	exports: [TopRibbonComponent],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatButtonModule,
		MatDividerModule,
		MatIconModule,
		MatMenuModule,
		MatToolbarModule,
		RouterModule,
		TranslocoModule
	]
})
export class TopRibbonModule {}
